import {
  FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL,
  FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL_SUCCESS,
  FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL_FAILURE,
  IMPORT_TAX_RATES,
  IMPORT_TAX_RATES_SUCCESS,
  IMPORT_TAX_RATES_FAILURE,
} from './types';
import {
  fetchEnabledFlagValues as fetchEnabledFlagValuesApi,
  fetchCountryCodes as fetchCountryCodesApi,
  fetchAccountCodes as fetchAccountCodesApi,
  importTaxRates as importTaxRatesApi,
} from '../api';

import getActions from '../../shared/store/actionsFactory';
import { adminPageNames, adminPageTitles } from '../../shared/adminPageNames';
import getApi from '../../shared/apiFactory';
import Config from '../../../config';


import { fetchingError } from '../../../shared/store/actions';
import { errorNotification } from '../../../shared/store/notificationActions';

import agGridConfig from '../../../agGridConfig';
import { MIN_COLUMNS_NUMBER, MAX_COLUMNS_NUMBER, columnHeaders, GRID_FIELD_MAPPINGS } from '../xlsxImport/constants';
import fixDataTypes from '../xlsxImport/fixDataTypes.processor';

export const fetchInitialDataForTaxRateModal = ({
  period,
}) => async dispatch => {
  dispatch({
    type: FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL,
  });
  try {
    const enabledFlagValuesResponse = await fetchEnabledFlagValuesApi();
    const countryCodesResponse = await fetchCountryCodesApi({ periodName: period.name });
    const accountCodesResponse = await fetchAccountCodesApi();

    return dispatch({
      type: FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL_SUCCESS,
      enabledFlagValues: enabledFlagValuesResponse.map(
        ({ name, value }) => ({ value, label: name })
      ),
      countryCodes: countryCodesResponse.map(
        ({ countryCode, countryDescription }) => ({ value: countryCode, label: countryDescription })
      ),
      accounts: accountCodesResponse,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      dispatch({
        type: FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL_FAILURE,
      });
      return;
    }
    throw error;
  }
};

export const sharedActions = getActions(
  adminPageNames.TAX_RATES,
  {
    pageTitle: adminPageTitles.TAX_RATES,
    api: getApi({
      pageTitle: adminPageTitles.TAX_RATES,
      endpoints: {
        FETCH: Config.endpoints.FETCH_TAX_RATES,
        INSERT: Config.endpoints.ADD_TAX_RATE,
        UPDATE: Config.endpoints.UPDATE_TAX_RATE,
        DELETE: Config.endpoints.DELETE_TAX_RATE,
        VALIDATE: Config.endpoints.VALIDATE_TAX_RATES,
        IMPORT: Config.endpoints.IMPORT_TAX_RATES,
      },
    }),
    sortingField: 'countryTaxType',
    agGridConfig: agGridConfig.adminTaxRates,
    excel: {
      sheetName: 'Tax Rates',
      lastColumnLetter: 'K',
      columnHeaders,
      dataTypesProcessor: fixDataTypes,
      fieldMappings: GRID_FIELD_MAPPINGS,
      minColumnsNumber: MIN_COLUMNS_NUMBER,
      maxColumnsNumber: MAX_COLUMNS_NUMBER,
    },
  });

export const importTaxRatesFromXlsx = (taxRates, periodName) => async dispatch => {
  dispatch({
    type: IMPORT_TAX_RATES,
  });
  try {
    await importTaxRatesApi(taxRates, periodName);
    dispatch({
      type: IMPORT_TAX_RATES_SUCCESS,
    });
  } catch (error) {
    dispatch(errorNotification(error.message));
    dispatch({
      type: IMPORT_TAX_RATES_FAILURE,
    });
  }
};
